import { getSiteBaseUrl } from './siteBaseUrl'

export type BannerTab = 'shipping' | 'shopping'

export function getInsurancePath(type: BannerTab) {
	const isProd = import.meta.env.PROD
	const baseUrl = isProd ? getSiteBaseUrl() : ''

	const pathMap: Record<BannerTab, string> = {
		shipping: isProd
			? '/protection/shipping/'
			: '/shipment-protection-shipping',
		shopping: isProd
			? '/protection/shopping/'
			: '/shipment-protection-shopping',
	}

	return `${isProd ? baseUrl : ''}${pathMap[type]}`
}

export function smoothScrollToElement(element: HTMLElement | null) {
	if (element) {
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'nearest',
			inline: 'center',
		})
	}
}

export function getButtonName(theme: string) {
	let buttonName
	if (theme.toLowerCase().trim().includes('plus')) {
		buttonName = 'Plus'
	} else {
		buttonName = 'Basic'
	}

	return buttonName
}
